import { Component, Inject } from '@angular/core';
import { Sitemap } from '../interfaces/sitemap';
import { Site } from '../interfaces/site';
import { DOCUMENT } from '@angular/common';
import { SiteApiService } from '../services/site-api.service';
import { GapiService } from '../services/gapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTransferService } from '../services/data-transfer.service';
import { IndexingApiService } from '../services/indexing-api.service';
import { Title } from '@angular/platform-browser';
import { UserApiService } from '../services/user-api.service';
import { SitemapApiService } from '../services/sitemap-api.service';
import { SeoToolsApiService } from '../services/seotools-api.service';
import * as Sentry from '@sentry/browser';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-manage-sites',
  templateUrl: './manage-sites.component.html',
  styleUrls: ['./manage-sites.component.css'],
  styles: [
    `.modal{background: rgba(0,0,0, .5);}`
  ]
})
export class ManageSitesComponent {
  public sites: Site[] = [];
  public sitemaps: Sitemap[] = [];
  display = "none";
  showModalClass = false;
  urls: string = "";
  autoIndexUrls: string = "";
  showMessage = false;
  showGrantAccessSpinner = false;
  message = "";
  alertType: number = 1;
  selectedSiteId: any
  urlsSplittedCount = 0;
  autoIndexUrlsSplittedCount = 0;
  showSpinner = true;
  showServiceAccountModalSpinner = false;
  showCheckSeoModalSpinner = false;
  showAutoIndexingQueueSpinner = false;
  userPlan = { enabledSiteCount: 0, hasAutoIndexingFeature: false, allowedIndexingQuota: 0 };
  enabledSiteCount = 0;
  showSitemapSpinner = false;
  selectedSiteUrl: any;
  serviceAccountEmail = "";
  showIndexingSpinner = false;
  serviceAccounts: any[] = []
  seoResults: any
  autoIndexType = 0;

  constructor(@Inject(DOCUMENT) private document: Document,
    private siteApiService: SiteApiService,
    private userApiService: UserApiService,
    private sitemapApiService: SitemapApiService,
    private indexingApiService: IndexingApiService,
    private seoToolsApiService: SeoToolsApiService,
    private gapiService: GapiService,
    private router: Router,
    private socialAuthService: SocialAuthService,
    private routeTransferData: DataTransferService,
    private route: ActivatedRoute,
    private titleService: Title) {
    this.titleService.setTitle("Manage Sites | Rankahead.app");
  }

  ngOnInit() {
    this.document.body.classList.remove('toggle-sidebar');
    //myUndefinedFunction();

    this.route.queryParams.subscribe(params => {
      let token = params['tk'];

      if (token != null) {
        localStorage.setItem("ut", token);
      }

      this.loadSites();
      this.getUserSubscriptionPlan();
      this.getServiceAccounts();

    });
  }

  getUserSubscriptionPlan() {
    this.userApiService.getUserSubscriptionPlan().subscribe((response: any) => {
      if (response != null && response.plan != null) {
        switch (response.plan) {
          case "starter":
            this.userPlan = { enabledSiteCount: 0, hasAutoIndexingFeature: false, allowedIndexingQuota: 0 };
            localStorage.setItem("plan", JSON.stringify(this.userPlan));
            break;

          case "basic":
            this.userPlan = { enabledSiteCount: 3, hasAutoIndexingFeature: true, allowedIndexingQuota: 200 };
            localStorage.setItem("plan", JSON.stringify(this.userPlan));
            break;

          case "pro":
            this.userPlan = { enabledSiteCount: 10, hasAutoIndexingFeature: true, allowedIndexingQuota: 400 };
            localStorage.setItem("plan", JSON.stringify(this.userPlan));
            break;

          case "enterprise":
            this.userPlan = { enabledSiteCount: 50, hasAutoIndexingFeature: true, allowedIndexingQuota: 600 };
            localStorage.setItem("plan", JSON.stringify(this.userPlan));
            break;
        }
      }
      else {
        this.userPlan = { enabledSiteCount: 0, hasAutoIndexingFeature: false, allowedIndexingQuota: 0 };
        localStorage.setItem("plan", JSON.stringify(this.userPlan));
      }
    });
  }

  getSitemapsFromGapi(siteUrl: any, siteId: any) {
    this.sitemaps = [];
    this.showSitemapSpinner = true;
    this.gapiService.loadGapi().then(x => {
      this.gapiService.getSitemaps(siteUrl).then((sitemapsResponse: any | undefined) => {
        if (sitemapsResponse?.result?.sitemap != null) {
          var sitemapsToPost: any = [];
          for (var i = 0; i < sitemapsResponse?.result?.sitemap.length; i++) {
            var sitemap = { url: sitemapsResponse?.result?.sitemap[i]?.path, siteId: siteId }
            sitemapsToPost.push(sitemap);
          }
          this.sitemapApiService.postSitemaps(sitemapsToPost).subscribe((postSitemapsResponse: any) => {
            for (var i = 0; i < postSitemapsResponse.length; i++) {
              let sitemapDetail = {
                submittedUrls: postSitemapsResponse[i].urlCount,
                url: postSitemapsResponse[i].url,
                isEnabled: false,
                id: postSitemapsResponse[i].id,
              } as Sitemap;

              this.sitemaps.push(sitemapDetail);

              this.showSitemapSpinner = false;
            }
          });
        }
        else {
          this.showSitemapSpinner = false;
        }
      }).catch((err: any) => {
        this.showSitemapSpinner = false;
        if (err != null && err.status != null && err.status == 403) {
          this.showAlert(0, "Rank Ahead does not have access to your sitemaps. Please make sure to check the checkbox ('View Search Console data for your verified sites') when logging in with your Google Account.");
        }
        else {
          this.showAlert(0, "An error occured while fetching sitemaps.");
        }
        Sentry.captureException(err);
      });
    }).catch((err: any) => {
      this.showSitemapSpinner = false;
      this.showAlert(0, "An error occured while fetching sitemaps.");
      Sentry.captureException(err);
    })
  }

  getSitemaps(siteUrl: string, siteId: any) {
    this.selectedSiteUrl = siteUrl;
    this.selectedSiteId = siteId;

    this.showSitemapSpinner = true;
    this.sitemaps = [];

    this.sitemapApiService.getSitemaps(siteId).subscribe((response: any) => {
      if (response.length == 0) {
        this.getSitemapsFromGapi(siteUrl, siteId);
      }
      else {
        for (var i = 0; i < response.length; i++) {
          let sitemapDetail = {
            isEnabled: response[i].isEnabled,
            submittedUrls: response[i].urlCount,
            url: response[i].url,
            id: response[i].id
          } as Sitemap;

          this.sitemaps.push(sitemapDetail);
          this.showSitemapSpinner = false;
        }
      }
    }, error => {
      this.showSitemapSpinner = false;
      this.showAlert(0, "An error occured while fetching sitemaps.");
      Sentry.captureException(error);
    })
  }

  updateSitemap(sitemap: any) {
    this.sitemapApiService.updateSitemap(sitemap).subscribe((response: any) => {
      this.showAlert(1, "Sitemap has been updated successfully.")
    })
  }

  openModal() {
    this.display = "block";
    this.showModalClass = true;
  }

  formatSiteUrlForSitemapRequest(siteUrl: string) {
    var siteUrlFormatted = siteUrl.replace("sc-domain:", "").replace("https://", "").replace("http://", "").replace("www.", "");

    if (siteUrlFormatted.endsWith("/")) {
      siteUrlFormatted = siteUrlFormatted.slice(0, -1);
    }

    return siteUrlFormatted;
  }

  loadSites() {
    this.siteApiService.getSites().subscribe((sitesResponse: any) => {
      if (sitesResponse == null || sitesResponse.length == 0) {
        this.getSitesFromGapi();
      }
      else {
        this.sites = sitesResponse as Site[];
        this.enabledSiteCount = this.sites.filter(x => x.isEnabled).length;
        this.showSpinner = false;
        this.getGscAccess(false);
      }
    })
  }

  getGscAccess(fullCheck: boolean) {
    this.showGrantAccessSpinner = true;
    this.indexingApiService.getGscAccess(fullCheck).subscribe((response: any) => {
      debugger;
      this.showGrantAccessSpinner = false;
      if (response != null) {
        for (var i = 0; i < this.sites.length; i++) {
          var siteAccess = response.filter((x: any) => x.site == this.sites[i].url);

          if (siteAccess != null && siteAccess.every((x: any) => x.isAccessGranted == true)) {
            this.sites[i].isAccessGranted = true;
          }
          else {
            this.sites[i].isAccessGranted = false;
          }
        }
      }
    }, (error: any) => this.showGrantAccessSpinner = false)
  }

  getSitesFromGapi() {
    //throw new Error("Custom error");
    this.showSpinner = true;
    this.gapiService.loadGapi().then(x => {
      this.gapiService.getSites().then((response: { result: { siteEntry: any }; }) => {
        let sitesToPost: any[] = [];

        for (var i = 0; i < response.result.siteEntry.length; i++) {
          let permissionLevel = response.result.siteEntry[i].permissionLevel;
          let siteUrl = response.result.siteEntry[i].siteUrl;
          let siteUrlFormatted = this.formatSiteUrlForSitemapRequest(siteUrl);

          sitesToPost.push({
            Url: siteUrl,
            IsEnabled: false,
            IsAutoIndexingEnabled: false,
            favIconUrl: "https://icon.horse/icon/" + siteUrlFormatted,
            permissionLevel: permissionLevel,
            autoIndexType: 0,
          })
        }

        if (sitesToPost.length > 0) {
          this.siteApiService.postSites({ sites: sitesToPost }).subscribe((response: any) => {
            this.sites = [];

            for (var i = 0; i < response.length; i++) {
              this.sites.push({
                id: response[i].id,
                url: response[i].url,
                isEnabled: response[i].isEnabled,
                isAutoIndexingEnabled: response[i].isAutoIndexingEnabled,
                favIconUrl: response[i].favIconUrl,
                dailyQuotaLimit: response[i].dailyQuotaLimit,
                permissionLevel: response[i].permissionLevel,
                autoIndexType: response[i].autoIndexType,
                isAccessGranted: false
              });
            }

            this.getGscAccess(true);

            this.showSpinner = false;
          });
        }
        else {
          this.showSpinner = false;
        }
      }).catch((error: any) => {
        this.showSpinner = false;

        if (error?.body != null)
          Sentry.captureException(error.body);

        //if (error?.result?.error?.status == "UNAUTHENTICATED") {
        //  localStorage.removeItem("access_token");
        //  localStorage.removeItem("token");

        //  this.router.navigateByUrl("/signin");
        //}

        if (error?.status == 403 || error?.status == 401) {
          setTimeout(() => {
            this.socialAuthService.signOut();
            localStorage.removeItem("ut");
            localStorage.removeItem("plan");
            this.router.navigateByUrl("/signin/permission-issue");
          }, 2000);
        }
      })
    }).catch((error: any) => {
      this.showSpinner = false;
      this.showAlert(0, "An error occured while fetching your websites. Error Code: GAPIx0001");
      Sentry.captureException(error);
    });
  };

  indexUrls() {
    let urlsSplitted = this.urls.trim().split(/[\s,]+/);

    for (var i = 0; i < urlsSplitted.length; i++) {
      // Check if urls are valid
      if (!this.isValidUrl(urlsSplitted[i])) {
        this.showAlert(0, "Wrong format of urls. Please check your input.");

        return;
      }
    }

    // Check if there are more than 100 Urls
    if (urlsSplitted.length > 100) {
      this.showAlert(0, "You can submit maximum 100 urls at a time.");
      return;
    }

    this.showIndexingSpinner = true;
    this.indexingApiService.batchAddUpdateIndex(this.selectedSiteId, urlsSplitted).subscribe((response: any) => {
      if (response != null) {
        if (response.length == 0) {
          this.showAlert(0, `Indexing URLs failed because you exceeded your quota.`);
          this.showIndexingSpinner = false;
          // Close Modal
          this.closeModals();
          return;
        }

        let quotaErrorCount = response.filter((x: any) => x.statusCode == 429).length;
        let successCount = response.filter((x: any) => x.statusCode == 200).length;
        let forbiddenCount = response.filter((x: any) => x.statusCode == 403).length;

        if (successCount > 0) {
          this.alertType = 1;
          this.message = `${successCount} Urls have been submitted successfully!`;

          if (quotaErrorCount > 0)
            this.message += `Indexing ${quotaErrorCount} URLs failed because you exceeded your quota.`

          this.showMessage = true;
          this.showIndexingSpinner = false;

          // Close Modal
          this.closeModals();

          // Reset urls
          this.urls = "";

          setTimeout(() => {
            this.showMessage = false;
            this.message = "";
          }, 5000);
        }
        else {
          if (quotaErrorCount == urlsSplitted.length) {
            this.alertType = 0;
            this.message += `Indexing ${quotaErrorCount} URLs failed because you exceeded your quota.`
            this.showMessage = true;
            this.showIndexingSpinner = false;

            setTimeout(() => {
              this.showMessage = false;
              this.message = "";
            }, 5000);
          }
          else {
            var alertMessage = "";

            if (forbiddenCount > 0)
              alertMessage = "Either you exceeded your daily quota or there is an issue with your access. Please double check your access on Google Search Console, if problem still persist please contact us on support@rankahead.app";
            else
              alertMessage = "An error occured while submitting urls.";

            this.showAlert(0, alertMessage);
            this.showIndexingSpinner = false;
          }
        }
      }
    }, err => {
      this.showAlert(0, err.error);
      this.showIndexingSpinner = false;
    });
  }

  isValidUrl(url: string) {
    try {
      new URL(url);
      return true;
    } catch (err) {
      return false;
    }
  }

  updateSite(site: Site, updateType: number) {
    // update is enabled
    if (updateType == 0) {
      if (site.permissionLevel != "Owner") {
        this.showAlert(0, "You need full owner permission to start indexing for this site.");
        return;
      }

      if (this.userPlan.enabledSiteCount != 0) {
        if (site.isEnabled && this.enabledSiteCount == this.userPlan.enabledSiteCount) {
          this.showAlert(0, "Upgrade your plan to enable more sites.");

          this.loadSites();
        }
        else {
          this.siteApiService.updateSite(site).subscribe((sitesResponse: any) => {
            if (site.isEnabled) {
              this.enabledSiteCount++;
              this.getGscAccess(true);
            }

            else
              this.enabledSiteCount--;
          })
        }
      }
    }
    // update auto indexing
    else {
      if (site.isAutoIndexingEnabled && !this.userPlan.hasAutoIndexingFeature) {
        this.showAlert(0, "Upgrade your plan to use Auto Indexing feature.");
        this.loadSites();
      }
      else {
        this.siteApiService.updateSite(site).subscribe((sitesResponse: any) => {
        })
      }
    }
  }

  setClickedSiteId(id: any) {
    this.selectedSiteId = id;
  }

  urlsChanged() {
    this.urlsSplittedCount = 0;
    let urlsSplitted = this.urls.trim().split(/[\s,]+/);

    for (var i = 0; i < urlsSplitted.length; i++) {
      // Check if urls are valid
      if (this.isValidUrl(urlsSplitted[i])) {
        this.urlsSplittedCount++;
      }
    }
  }

  autoIndexUrlsChanged() {
    this.autoIndexUrlsSplittedCount = 0;
    let urlsSplitted = this.autoIndexUrls.trim().split(/[\s,]+/);

    for (var i = 0; i < urlsSplitted.length; i++) {
      // Check if urls are valid
      if (this.isValidUrl(urlsSplitted[i])) {
        this.autoIndexUrlsSplittedCount++;
      }
    }
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }

  parseJwt(token: any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  closeModals() {
    let modals = this.document.getElementsByClassName("btn-modal-close");

    for (var i = 0; i < modals.length; i++) {
      (modals[i] as HTMLElement).click();
    }
  }

  dailyQuotaLimitChange(siteId: any, limit: any) {
    //if (limit == null) limit = 0;

    this.siteApiService.setDailyQuotaLimit(siteId, limit).subscribe(response => {
      this.showAlert(1, "Daily quota limit has been successfully saved.")
    }, error => this.showAlert(0, error.error));
  }

  createCloudProject(projectNumber: any) {
    this.showServiceAccountModalSpinner = true;
    this.indexingApiService.createCloudProject(projectNumber).subscribe((email: any) => {
      this.serviceAccountEmail = email;
      this.showServiceAccountModalSpinner = false;
    }, error => {
      this.showServiceAccountModalSpinner = false
      this.showAlert(0, error.error);
    })
  }

  copyTextToClipboard(val: string) {
    // Copy the text
    navigator.clipboard.writeText(val);

    this.showAlert(1, "Email copied!")
  }

  upgradePlan() {
    location.href = "/pricing";
  }

  setSiteDisabled(event: any) {
    event.currentTarget.checked = false
  }

  getServiceAccounts() {
    // Get service accounts
    this.userApiService.getServiceAccounts().subscribe(response => {
      this.serviceAccounts = response as [];
    })
  }

  checkSeo(url: string) {
    this.seoResults = null;
    this.showCheckSeoModalSpinner = true;
    var siteUrlFormatted = this.formatSiteUrlForSitemapRequest(url);

    this.seoToolsApiService.checkSeo(siteUrlFormatted, 0).subscribe(response => {
      this.seoResults = response;
      this.showCheckSeoModalSpinner = false;
    }, (error: any) => {
      this.showCheckSeoModalSpinner = false;
      this.showAlert(0, "An error occured while retrieving SEO results.");
    })
  }

  addUrlsToQueue() {
    let urlsSplitted = this.autoIndexUrls.trim().split(/[\s,]+/);

    for (var i = 0; i < urlsSplitted.length; i++) {
      // Check if urls are valid
      if (!this.isValidUrl(urlsSplitted[i])) {
        this.showAlert(0, "Wrong format of urls. Please check your input.");

        return;
      }
    }

    // Check if there are more than 1000 Urls
    if (urlsSplitted.length > 1000) {
      this.showAlert(0, "You can submit maximum 1000 urls at a time.");
      return;
    }

    this.showAutoIndexingQueueSpinner = true;

    this.indexingApiService.addUrlsToAutoIndexQueue(this.selectedSiteId, urlsSplitted).subscribe((response: any) => {
      this.showAutoIndexingQueueSpinner = false;
      this.closeModals();
      this.autoIndexUrls = "";
      if (response == true) {
        this.showAlert(1, "URLs have been added to queue.");
      }
    }, error => {
      this.showAutoIndexingQueueSpinner = false;
      this.showAlert(0, "An error occured while adding URLs to queue.");
      this.closeModals();
      this.autoIndexUrls = "";
      Sentry.captureException(error);
    })
  }

  onAutoIndexTypeChanged() {
    this.siteApiService.setAutoIndexType(this.selectedSiteId, this.autoIndexType).subscribe(response => {
      var filteredSites = this.sites.filter(x => x.id == this.selectedSiteId);

      if (filteredSites != null && filteredSites[0] != null) {
        filteredSites[0].autoIndexType = this.autoIndexType;

        if (this.autoIndexType == 1) {
          this.getSitemaps(filteredSites[0].url, filteredSites[0].id);
        }
      }
    });
  }

  setAutoIndexTypeForSelectedSite(site: any) {
    this.selectedSiteId = site.id;
    this.autoIndexType = site.autoIndexType;

    if (this.autoIndexType == 1) {
      this.getSitemaps(site.url, site.id);
    }
  }
}
